import PropTypes from 'prop-types';

// Every step gets the same props: the payload's product + choices + readiness,
// and the callbacks that write through the server's apply_* methods. Shared so
// the shape is declared once rather than in eight files.
export const stepPropTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    product_type: PropTypes.string,
    season: PropTypes.string,
    tagline: PropTypes.string,
    description: PropTypes.string,
    active: PropTypes.bool,
    legacy_package_id: PropTypes.number,
    legacy_package_name: PropTypes.string,
    card_image_id: PropTypes.number,
    style_ids: PropTypes.arrayOf(PropTypes.number),
    style_required: PropTypes.bool,
    upsell_override: PropTypes.bool,
    upsell_steps: PropTypes.arrayOf(PropTypes.string),
    ships: PropTypes.bool,
    shipping_price: PropTypes.number,
    background_set_id: PropTypes.number,
    background_count: PropTypes.number,
    pose_order: PropTypes.arrayOf(PropTypes.string),
    pose_backgrounds: PropTypes.arrayOf(PropTypes.object),
    printess_template_id: PropTypes.string,
    setup_notes: PropTypes.arrayOf(PropTypes.string),
    variants: PropTypes.arrayOf(PropTypes.object),
    schools: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  choices: PropTypes.shape({
    // Shop::SeasonChoices objects, not bare strings -- they carry the label and the
    // group the pickers order by.
    seasons: PropTypes.arrayOf(PropTypes.object),
    backgrounds: PropTypes.arrayOf(PropTypes.object),
    background_sets: PropTypes.arrayOf(PropTypes.object),
    extras: PropTypes.arrayOf(PropTypes.object),
    print_lines: PropTypes.arrayOf(PropTypes.object),
    packages: PropTypes.arrayOf(PropTypes.object),
    package_options: PropTypes.arrayOf(PropTypes.object),
    styles: PropTypes.arrayOf(PropTypes.object),
    upsell_steps: PropTypes.arrayOf(PropTypes.object),
    inherited_upsell: PropTypes.arrayOf(PropTypes.string),
    assignable_schools: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  readiness: PropTypes.shape({
    state: PropTypes.string,
    checklist: PropTypes.arrayOf(PropTypes.object),
    warnings: PropTypes.arrayOf(PropTypes.string),
  }),
  steps: PropTypes.arrayOf(PropTypes.object),
  preview: PropTypes.shape({
    samplePose: PropTypes.shape({ watermark_url: PropTypes.string }),
  }),
  busy: PropTypes.bool,
  // Saves one step through PATCH .../wizard -> the server's apply_* method.
  commit: PropTypes.func.isRequired,
  autosave: PropTypes.func,
  reload: PropTypes.func,
  setOverrides: PropTypes.func,
  goTo: PropTypes.func,
};

export const stepDefaultProps = {
  readiness: null,
  steps: [],
  preview: null,
  busy: false,
  autosave: () => {},
  reload: () => {},
  setOverrides: () => {},
  goTo: () => {},
};
